
    function test_ready(fn){
	    if(document.addEventListener){
		      	document.addEventListener('DOMContentLoaded',function(){
			       	document.removeEventListener('DOMContentLoaded',arguments.callee,false);
			       	fn();
		      	},false);
	     }else if(document.attachEvent){
		      document.attachEvent('onreadystatechange',function(){
			       if(document.readyState=='complete'){
			        	document.detachEvent('onreadystatechange',arguments.callee);
			        	fn();
			       }
		      });
	    }
    }
  
  test_ready(() => {            
		jQuery('.product-description .tabs.ymq_pc_show li').click(function(){
  jQuery('.product-description .tabs li').removeClass('active');
  jQuery(this).addClass('active');
  jQuery('.tabs-content-item').removeClass('active');
  jQuery('.'+jQuery(this).data('tab')).addClass('active');
})
jQuery('.product-description .tabs.ymq_m_show li').click(function(){
  jQuery('.ymq_m_show li').removeClass('grouped-content-trigger');
  if (jQuery('.'+jQuery(this).data('tab')).hasClass('active')) {
    jQuery(this).removeClass('active');
    jQuery('.'+jQuery(this).data('tab')).removeClass('active');
  }else{
    jQuery(this).addClass('active');
    jQuery('.'+jQuery(this).data('tab')).addClass('active');
  }
}) 
jQuery('.downloads-tab,.accessorie-tab').click();
  jQuery('.downloads-tab,.accessorie-tab').click().removeClass('active');
	
  })

// product title 前tag位置
// let titleTag = $(".product-description .b-red")
// let titleTag2 = $(".product-description .b-green")
// if(titleTag2){
//   $(".product-details .product-title").prepend(titleTag2)
// }
// if(titleTag){
//   $(".product-details .product-title").prepend(titleTag)
// }


// 如果announcement-bar存在，announcement-bar固定顶部，header下移固定
$(function(){
  if($(".announcement-bar").length > 0){
    $("header").attr("data-have-announcement",'true')
  }
})